var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHint({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.003 9a.977.977 0 00.702-.285.955.955 0 00.295-.718.959.959 0 00-.295-.702.959.959 0 00-.702-.295.965.965 0 00-.708.295.959.959 0 00-.295.702c0 .275.098.51.295.708a.965.965 0 00.708.295zM15 17v-2h-2v-5H9v2h2v3H9v2h6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.785 1.09l-3.952.003c-2.727.028-3.888.363-5.022.97A6.608 6.608 0 002.062 4.81c-.634 1.186-.971 2.4-.971 5.404l.002 3.951c.028 2.727.363 3.889.97 5.022a6.608 6.608 0 002.748 2.75c1.186.634 2.4.971 5.404.971h3.57c3.003 0 4.218-.337 5.403-.971a6.608 6.608 0 002.75-2.75c.634-1.185.971-2.4.971-5.403v-3.57c0-3.003-.337-4.218-.971-5.404a6.608 6.608 0 00-2.75-2.749c-1.185-.634-2.4-.971-5.403-.971zm-4.72 1.924A35.6 35.6 0 0110.107 3l4.155.001c.238.002.462.007.673.013l.594.025c1.395.08 2.14.29 2.883.687a4.439 4.439 0 011.861 1.862c.398.743.608 1.487.688 2.883l.025.594.008.326.006.716v3.786l-.006.716-.008.326-.025.594c-.08 1.395-.29 2.14-.688 2.883a4.438 4.438 0 01-1.86 1.861c-.744.398-1.489.608-2.884.688l-.594.025-.326.008-.716.006h-3.786l-.716-.006-.326-.008-.594-.025c-1.396-.08-2.14-.29-2.883-.688a4.439 4.439 0 01-1.862-1.86c-.397-.744-.607-1.489-.687-2.884l-.025-.594c-.01-.316-.014-.662-.014-1.042v-3.786l.006-.716.008-.326.025-.594c.08-1.396.29-2.14.687-2.883a4.439 4.439 0 011.862-1.862C6.33 3.33 7.075 3.12 8.47 3.04l.594-.025z"
  })));
}

export default SvgHint;